import { cn } from '../../lib/utils';

/**
 * FormContainer component for standardized form and page containers
 * Matches form_styles.md patterns for consistent spacing and layout
 */

/**
 * FormContainer - Main form container with space-y-6 spacing
 * Used for wrapping form content with consistent vertical spacing
 */
export const FormContainer = ({ children, className, ...props }) => {
  return (
    <form className={cn('space-y-6', className)} {...props}>
      {children}
    </form>
  );
};

FormContainer.displayName = 'FormContainer';

/**
 * PageContainer - Standardized page container with responsive padding
 * Max width: max-w-7xl (1280px)
 * Horizontal padding: px-4 sm:px-6 lg:px-8 (responsive: 16px → 24px → 32px)
 * Vertical padding: py-8 (32px)
 */
export const PageContainer = ({ children, className, ...props }) => {
  return (
    <div 
      className={cn(
        'max-w-7xl mx-auto',
        'px-4 sm:px-6 lg:px-8',
        'py-8',
        className
      )} 
      {...props}
    >
      {children}
    </div>
  );
};

PageContainer.displayName = 'PageContainer';
